/* eslint-disable camelcase */
import { fetchAll } from '@/api/center'
import { fetchAuthCenter } from '@/api/coach'


const state = {
  list: [],
  items: [],
}

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list
  },
  SET_ITEMS: (state, items) => {
    state.items = items
  },
}

const actions = {
  list({ commit }) {
    return new Promise((resolve, reject) => fetchAll()
      .then(response => {
        console.log('center list response', response)
        const { data } = response
        commit('SET_LIST', data.items)
        const items = []
        data.items.forEach(item => items.push({
          itemValue: item.id,
          itemName: `${item.id}`,
          label: `${item.code}`,
        }))
        commit('SET_ITEMS', items)
        resolve(data)
      })
      .catch(error => {
        console.log('error', error)
        reject(error)
      }))
  },

  authcenterlist({ commit }) {
    return new Promise((resolve, reject) => fetchAuthCenter()
      .then(response => {
        console.log('center list response', response)
        const { data } = response
        commit('SET_LIST', data.items)
        const items = []
        data.items.forEach(item => items.push({
          itemValue: item.id,
          itemName: `${item.id}`,
          label: `${item.code}`,
        }))
        commit('SET_ITEMS', items)
        resolve(data)
      })
      .catch(error => {
        console.log('error', error)
        reject(error)
      }))
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
